'use client';

import { useState } from 'react';
import { Link2, Check } from 'lucide-react';

const SHARE_TITLE = 'Rewards Store Field Guide — LiveSchool';
const SHARE_TEXT =
  'A free, practical guide to building a school rewards system students love.';

function FacebookIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
    </svg>
  );
}

function XIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  );
}

export function ShareButtons({ className }: { className?: string }) {
  const [copied, setCopied] = useState(false);

  const getUrl = () =>
    typeof window !== 'undefined' ? window.location.href.split('#')[0] : '';

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(getUrl());
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // fallback: do nothing
    }
  };

  const shareFacebook = () => {
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(getUrl())}`,
      '_blank',
      'width=600,height=400',
    );
  };

  const shareX = () => {
    window.open(
      `https://x.com/intent/tweet?url=${encodeURIComponent(getUrl())}&text=${encodeURIComponent(SHARE_TEXT)}`,
      '_blank',
      'width=600,height=400',
    );
  };

  const btnBase =
    'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium transition-colors cursor-pointer';

  return (
    <div className={`flex items-center gap-2 flex-wrap ${className ?? ''}`}>
      <span className="text-sm font-medium opacity-60 mr-1">Share</span>
      <button
        onClick={copyLink}
        className={`${btnBase} bg-black/5 hover:bg-black/10`}
        aria-label="Copy link"
      >
        {copied ? <Check className="w-3.5 h-3.5" /> : <Link2 className="w-3.5 h-3.5" />}
        {copied ? 'Copied!' : 'Copy link'}
      </button>
      <button
        onClick={shareFacebook}
        className={`${btnBase} bg-black/5 hover:bg-black/10`}
        aria-label="Share on Facebook"
      >
        <FacebookIcon className="w-3.5 h-3.5" />
        Facebook
      </button>
      <button
        onClick={shareX}
        className={`${btnBase} bg-black/5 hover:bg-black/10`}
        aria-label="Share on X"
      >
        <XIcon className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
